import * as React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Breadcrumbs, { breadcrumbsClasses } from '@mui/material/Breadcrumbs';
import { ChevronRight } from 'lucide-react';

const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
  margin: theme.spacing(1, 0),
  [`& .${breadcrumbsClasses.separator}`]: {
    color: theme.palette.action.disabled,
    margin: 1,
  },
  [`& .${breadcrumbsClasses.ol}`]: {
    alignItems: 'center',
  },
}));

export default function NavbarBreadcrumbs({ currentView }: { currentView: string }) {
  const getViewLabel = (view: string) => {
    switch(view) {
      case 'dashboard': return 'Dashboard';
      case 'projects': return 'Projects';
      case 'team': return 'Team';
      case 'timeline': return 'Timeline';
      default: return view.charAt(0).toUpperCase() + view.slice(1);
    }
  };

  return (
    <StyledBreadcrumbs
      aria-label="breadcrumb"
      separator={<ChevronRight size={14} />}
    >
      <Typography variant="body1">Project Manager</Typography>
      <Typography variant="body1" sx={{ fontWeight: 600, color: 'text.primary' }}>
        {getViewLabel(currentView)}
      </Typography>
    </StyledBreadcrumbs>
  );
}
